import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-766123c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-page__separator" }, null, -1))
const _hoisted_3 = {
  class: "main-page__request-form container",
  id: "request-form"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoBlock = _resolveComponent("VideoBlock")!
  const _component_OurProjects = _resolveComponent("OurProjects")!
  const _component_Services = _resolveComponent("Services")!
  const _component_WorkProcesses = _resolveComponent("WorkProcesses")!
  const _component_Faq = _resolveComponent("Faq")!
  const _component_ProjectPanorama = _resolveComponent("ProjectPanorama")!
  const _component_AppRequestForm = _resolveComponent("AppRequestForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VideoBlock),
    _createVNode(_component_OurProjects),
    _hoisted_2,
    _createVNode(_component_Services),
    _createVNode(_component_WorkProcesses),
    _createVNode(_component_Faq),
    _createVNode(_component_ProjectPanorama),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppRequestForm)
    ])
  ]))
}